module.exports = __webpack_public_path__ + "img/annotation.9e29af4c.png";